import React from 'react';
import moment from 'moment';
import commaNumber from 'comma-number';
import { Link } from 'react-router-dom'

import Modal from '../../common/components/Modal';
import RestrictedComponent from '../../lib/components/form/RestrictedComponent';
import schema from '../../routes/permissions/schema';

/*
{
    "campaignID": 28,
    "name": "some test campaign5",
    "description": null,
    "actionID": 5,
    "startDate": "2016-06-25 09:00:00",
    "endDate": "2016-06-27 09:00:00",
    "typeID": 3,
    "campaignAssets": [],
    "campaignCategoryIDs": null,
    "campaignEvents": null,
    "type": {
        "typeID": "3",
        "typeDesc": "event"
    },
    "actions": {
        "actionID": "5",
        "name": "pre-mid-post",
        "description": "Plays Ad at beginning, 50% and end of video"
    }
}
*/

class Campaign extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modal: false
        };

        this.handleDelete = this.handleDelete.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.renderModal = this.renderModal.bind(this)
    }

    handleDelete () {
        var props = this.props;
        this.props.actions.delete({
            campaignID: this.props.campaign.campaignID
        }, function (err, resp) {
            if (err) {
                props.emitSnack({
                    type: 'error',
                    message: err.message || err
                });
            } else {
                props.emitSnack({
                    type: 'success',
                    message: 'Campaign Deleted'
                });
            }
        });
    }

    toggleModal () {
        this.setState({
            modal: !this.state.modal
        });
    }

    render () {
        const { campaign } = this.props;

        function getSum (prop, list) {
            return list.map(function (x) {
                return parseInt((x[prop] || 0), 10);
            })
            .reduce(function (acc, n) {
                return acc + n;
            }, 0);
        }

        var plays = getSum('counts', campaign.campaignAssets);
        var clicks = getSum('clickCount', campaign.campaignAssets);

        var mode;
        switch (campaign.typeID) {
            case 1: mode = 'All Events'; break;
            case 2: mode = 'By Category'; break;
            case 3: mode = 'By Event'; break;
        }

        return (<div className="vast-campaign">
            <h4 className="vast-campaign__title">
                <span className="mode">
                    {mode}
                </span>

                {campaign.name}

            </h4>

            <div className="vast-campaign__actions">
                <RestrictedComponent permissionCheck={schema.MANAGE_ADS.UPDATE}>
                    <Link
                        to={'/manage/ads/edit?id=' + campaign.campaignID}
                        className="btn btn-default"
                    >
                        <i className="fa fa-pencil"/> Edit
                    </Link>
                </RestrictedComponent>
                <RestrictedComponent permissionCheck={schema.MANAGE_ADS.DELETE}>
                    <button className="btn btn-danger" onClick={this.toggleModal}>
                        <i className="fa fa-trash-can"/> Delete
                    </button>
                </RestrictedComponent>
            </div>

            <div className="vast-campaign__details">
                <small>
                    <strong>{moment(campaign.startDate).format('MMM. DD @h:mm a')}</strong> {
                        (campaign.endDate) ?
                            <span> to <strong>{moment(campaign.endDate).format('MMM. DD @h:mm a')}</strong></span> :
                            null
                    } | <RestrictedComponent permissionCheck={schema.MANAGE_ADS.READ}>
                            <Link to={'/manage/ads/analytics?id=' + campaign.campaignID}>
                                {commaNumber(plays) + (plays == 1 ? ' play' : ' plays')} {commaNumber(clicks) + (clicks == 1 ? ' click' : ' clicks')}
                            </Link>
                        </RestrictedComponent>
                </small>
            </div>

            {this.renderModal()}
        </div>);
    }

    renderModal () {
        if (this.state.modal) {
            return (<Modal
                saveAction={<button className="btn btn-danger" onClick={this.handleDelete}>
                    <i className="fa fa-trash-can"/> Delete
                </button>}
                cancelModal={this.toggleModal}>
                <Modal.Header>Delete Ad Campaign</Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger">
                        <h5>Are You Sure?</h5>
                        <p>This cannot be undone and you will lose all of your Campaign's Metadata including the any click metrics associated with it.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>);
        }
    }

}

export default Campaign;
